import { UI_ContentCardList } from 'ui/components/3-organisms/ContentCardList/ContentCardList';

interface Props {
	content: {
		heading: string;
		contentCards: Array<{
			content: {
				properties: {
					kicker: string;
					altText: string;
					heading: string;
					text: string;
					link: Content.Link | null;
					image: Content.Image | null;
				};
			};
			settings: {
				properties: {
					displayLinkAsButton: boolean;
					orientation: Content.Orientation;
					imageCropping: Content.ImageCropping;
				};
			};
		}>;
	};
}

export const ContentCardList = ({ content }: Props) => {
	return (
		<UI_ContentCardList
			heading={content?.heading}
			contentCardItems={content?.contentCards?.map(({ content, settings }) => {
				const { image, link, kicker, altText, heading, text } = content?.properties ?? {};
				const { displayLinkAsButton, orientation, imageCropping } = settings?.properties ?? {};

				return {
					image,
					link,
					kicker,
					altText,
					heading,
					text,
					displayLinkAs: displayLinkAsButton ? 'button' : null,
					orientation,
					imageCropping,
				};
			})}
		/>
	);
};
